import axios from 'axios'
// import { storageAxios } from '@/utils/axiosType'

export default {
  // 存储概览
  getStorageStat(params) {
    return axios.post('/api/rendering/admin/task/storage/getStorageStat', params)
  },
  // 分页查询input用户统计
  getUserInputStorageStatByBid(params) {
    return axios.post('/api/rendering/admin/task/storage/getUserInputStorageStatByBid', params)
  },
   // 分页查询output用户统计
  getUserOutputStorageStatByBid(params) {
    return axios.post('/api/rendering/admin/task/storage/getUserOutputStorageStatByBid', params)
  },
  // 清理空间
  cleanCustomerStore(params) {
    return axios.post('/api/rendering/admin/task/storage/cleanCustomerStore', params)
  },
  // 用户存储统计信息
  getUserStorageInfo(params) {
    return axios.post('/api/rendering/admin/task/storage/getUserStorageInfo', params)
  },
  // 用户存储白名单列表
  getCleanListForUser(params) {
    return axios.post('/api/rendering/admin/task/storage/getCleanListForUser', params)
  },
  // 用户存储白名单列表
  exportCleanListForUser(params) {
    return axios.post('/api/rendering/admin/task/storage/exportCleanListForUser', params)
  },
  // 存储管理列表
  queryByCondition(params) {
    return axios.post('/api/rendering/admin/task/mount/path/queryByCondition', params)
  },
  // 添加管理列表
  addMountPath(params) {
    return axios.post('/api/rendering/admin/task/mount/path/addMountPath', params)
  },
  // 删除存储管理列表
  deleteMountPath(params) {
    return axios.post('/api/rendering/admin/task/mount/path/deleteMountPath', params)
  },
  // 修改存储管理列表
  updateMountPath(params) {
    return axios.post('/api/rendering/admin/task/mount/path/updateMountPath', params)
  },
  // 新建转移任务
  generateTransferTask(params) {
    return axios.post('/api/rendering/admin/task/mount/path/generateTransferTask', params)
  },
  // 删除转移任务
  deleteTransferTask(params) {
    return axios.post('/api/rendering/admin/task/mount/path/deleteTransferTask', params)
  },
  // 获取转移任务列表
  getTransferTaskList(params) {
    return axios.post('/api/rendering/admin/task/mount/path/getTransferTaskList', params)
  },
  // 新增用户白名单
  addUserForCleanList(params) {
    return axios.post('/api/rendering/admin/task/storage/addUserForCleanList', params)
  },
  // 删除用户白名单
  deleteUserForCleanList(params) {
    return axios.post('/api/rendering/admin/task/storage/deleteUserForCleanList', params)
  },
  // 清空存储
  deleteStorageListCache(params) {
    return axios.post('/api/rendering/admin/task/storage/deleteStorageListCache', params)
  },
  // 新增input清理规则
  addInputUserForCleanList(params) {
    return axios.post('/api/rendering/admin/task/storage/addInputUserForCleanList', params)
  },
  // 新增output清理规则
  addOutputUserForCleanList(params) {
    return axios.post('/api/rendering/admin/task/storage/addOutputUserForCleanList', params)
  },
  // 编辑清理规则
  updateUserForCleanList(params) {
    return axios.post('/api/rendering/admin/task/storage/updateUserForCleanList', params)
  },
  // 设置雷速版本
  setRaySyncClientVersion(params) {
    return axios.post('/api/rendering/admin/task/common/setRaySyncClientVersion', params)
  },
  // 获取雷速版本
  getRaySyncClientVersion(params) {
    return axios.post('/api/rendering/admin/task/common/getRaySyncClientVersion', params)
  },
  // 实时存储
  queryStorageStat(params) {
    return axios.post('/api/rendering/admin/task/storage/queryStorageStat', params)
  },
  // 过期清理
  cleanUserStorageByExpireTime(params) {
    return axios.post('/api/rendering/admin/task/storage/cleanUserStorageByExpireTime', params)
  },
  // 获取自动清理记录
  getAutoClearLog(params) {
    return axios.post('/api/rendering/admin/task/storage/getAutoClearLog', params)
  },
  // 获取定时器
  getTimerList(params) {
    return axios.post('/api/rendering/admin/task/storage/getTimerList', params)
  },
  // 添加或编辑定时器
  addOrEditTimer(params) {
    return axios.post('/api/rendering/admin/task/storage/addOrEditTimer', params)
  },
  // 查询存储吞吐带宽
  queryBandwidth(params) {
    return axios.post('/api/rendering/admin/task/mount/path/queryBandwidth', params)
  },
   // 修改存储吞吐带宽
  editBandwidth(params) {
    return axios.post('/api/rendering/admin/task/mount/path/editBandwidth', params)
  },
  // 查询存储历史使用量
  queryStorageHistoricalUsage(params) {
    return axios.post('/api/rendering/admin/task/storage/queryStorageHistoricalUsage', params)
  },
  // 查询用户的存储历史使用量
  queryUsersStorageHistoryUsage(params) {
    return axios.post('/api/rendering/admin/task/storage/queryUsersStorageHistoryUsage', params)
  },
  // 查询用户任务存储规则
  queryUserTaskStorageRule(params) {
    return axios.post('/api/rendering/admin/task/storage/queryUserTaskStorageRule', params)
  },
  // 新增用户任务存储规则
  addUserTaskStorageRule(params) {
    return axios.post('/api/rendering/admin/task/storage/addUserTaskStorageRule', params)
  },
  // 编辑用户任务存储规则
  updateUserTaskStorageRule(params) {
    return axios.post('/api/rendering/admin/task/storage/updateUserTaskStorageRule', params)
  },
  // 删除用户任务存储规则
  deleteUserTaskStorageRule(params) {
    return axios.post('/api/rendering/admin/task/storage/deleteUserTaskStorageRule', params)
  },
  // Link挂载列表
  queryLinkMountList(params) {
    return axios.post('/api/rendering/admin/task/mount/path/link/queryByCondition', params)
  },
  // 新增Link挂载
  addLinkMount(params) {
    return axios.post('/api/rendering/admin/task/mount/path/link/add', params)
  },
  // 编辑Link挂载
  updateLinkMount(params) {
    return axios.post('/api/rendering/admin/task/mount/path/link/update', params)
  },
  // 删除Link挂载
  deleteLinkMount(params) {
    return axios.post('/api/rendering/admin/task/mount/path/link/delete', params)
  },
}
